// import { createSlice } from "@reduxjs/toolkit";

// const initialValue = {
//   resultData: [],
//   selectedSubject: "",
//   resultStatus: "",
//   examId: "",
//   isAfterObjectiveModalOpen: false,
//   tutorMark: 0,
//   from: "",
//   isEmpty: false,
//   examObj: {},
//   tutorPassedSubjective: "",
//   result: [],
//   isGraded: false,
//   examResultsArr: [],
//   pendingInterviewArr:[]
// };

// export const tutorExamSlice = createSlice({
//   name: "exam",
//   initialState: initialValue,

//   reducers: {
//     setResultData: (state, action) => {
//       state.resultData = action.payload;
//     },
//     setSelectedSubject: (state, action) => {
//       state.selectedSubject = action.payload;
//     },
//     setResultStatus: (state, action) => {
//       state.resultStatus = action.payload;
//     },
//     setExamId: (state, action) => {
//       state.examId = action.payload;
//     },
//     setIsAfterObjectiveModalOpen: (state, action) => {
//       state.isAfterObjectiveModalOpen = action.payload;
//     },
//     setTutorMark: (state, action) => {
//       state.tutorMark = action.payload;
//     },
//     setExamObj: (state, action) => {
//       state.examObj = action.payload;
//     },
//     setFrom: (state, action) => {
//       console.log("setFrom called with:", action.payload);
//       state.from = action.payload;
//     },
//     setIsEmpty: (state, action) => {
//       state.isEmpty = action.payload;
//     },
//     setTutorResult: (state, action) => {
//       state.result = action.payload;
//     },
//     setExamResultsArr: (state, action) => {
//       state.examResultsArr = action.payload;
//     },
//     setPendingInterviewArr: (state, action) => {
//       state.pendingInterviewArr = action.payload;
//     },
//     setIsGraded: (state) => {
//       state.isGraded = true;
//     },
//   },
// });

// export const {
//   setResultData,
//   setSelectedSubject,
//   setResultStatus,
//   setExamId,
//   setIsAfterObjectiveModalOpen,
//   setTutorMark,
//   setFrom,
//   setExamObj,
//   setIsEmpty,
//   setTutorPass,
//   setTutorResult,
//   setIsGraded,
//   setExamResultsArr,
//   setPendingInterviewArr
// } = tutorExamSlice.actions;

// export default tutorExamSlice.reducer;
import { createSlice } from "@reduxjs/toolkit";

const initialValue = {
  resultData: [],
  selectedSubject: "",
  resultStatus: "",
  examId: "",
  isAfterObjectiveModalOpen: false,
  tutorMark: 0,
  from: "",
  isEmpty: false,
  examObj: {},
  tutorPassedSubjective: "",
  result: [],
  isGraded: false,
  examResultsArr: [],
  pendingInterviewArr: [],
  currentExamData: null,
  examInProgress: false,
  examStartTime: null,
  examEndTime: null,
  currentQuestionIndex: 0,
  answeredQuestions: [],
  timeRemaining: null,
  examSettings: {
    timeLimit: 40, // minutes
    passingScore: 70, // percentage
    questionsPerExam: 25,
  },
};

export const tutorExamSlice = createSlice({
  name: "exam",
  initialState: initialValue,
  reducers: {
    setResultData: (state, action) => {
      state.resultData = action.payload;
    },

    setSelectedSubject: (state, action) => {
      state.selectedSubject = action.payload;
    },

    setResultStatus: (state, action) => {
      state.resultStatus = action.payload;
    },

    setExamId: (state, action) => {
      state.examId = action.payload;
    },

    setIsAfterObjectiveModalOpen: (state, action) => {
      state.isAfterObjectiveModalOpen = action.payload;
    },

    setTutorMark: (state, action) => {
      state.tutorMark = action.payload;
    },

    setExamObj: (state, action) => {
      state.examObj = action.payload;
    },

    setFrom: (state, action) => {
      console.log("setFrom called with:", action.payload);
      state.from = action.payload;
    },

    setIsEmpty: (state, action) => {
      state.isEmpty = action.payload;
    },

    setTutorResult: (state, action) => {
      state.result = action.payload;
    },

    setExamResultsArr: (state, action) => {
      state.examResultsArr = action.payload;
    },

    setPendingInterviewArr: (state, action) => {
      state.pendingInterviewArr = action.payload;
    },

    setIsGraded: (state) => {
      state.isGraded = true;
    },

    // New exam management reducers
    startExam: (state, action) => {
      const { examId, subject, questions, timeLimit } = action.payload;
      state.currentExamData = {
        examId,
        subject,
        questions,
        timeLimit: timeLimit || state.examSettings.timeLimit,
      };
      state.examInProgress = true;
      state.examStartTime = new Date().toISOString();
      state.currentQuestionIndex = 0;
      state.answeredQuestions = [];
      state.timeRemaining = (timeLimit || state.examSettings.timeLimit) * 60; // convert to seconds
    },

    endExam: (state, action) => {
      state.examInProgress = false;
      state.examEndTime = new Date().toISOString();
      state.result = action.payload?.result || [];
      state.resultStatus = action.payload?.status || "";
      state.tutorMark = action.payload?.marks || 0;
    },

    updateCurrentQuestion: (state, action) => {
      state.currentQuestionIndex = action.payload;
    },

    addAnsweredQuestion: (state, action) => {
      const { questionIndex, answer } = action.payload;
      const existingIndex = state.answeredQuestions.findIndex(
        q => q.questionIndex === questionIndex
      );
      
      if (existingIndex >= 0) {
        state.answeredQuestions[existingIndex].answer = answer;
      } else {
        state.answeredQuestions.push({ questionIndex, answer });
      }
    },

    updateTimeRemaining: (state, action) => {
      state.timeRemaining = action.payload;
    },

    resetExamState: (state) => {
      state.currentExamData = null;
      state.examInProgress = false;
      state.examStartTime = null;
      state.examEndTime = null;
      state.currentQuestionIndex = 0;
      state.answeredQuestions = [];
      state.timeRemaining = null;
      state.result = [];
      state.resultStatus = "";
      state.tutorMark = 0;
    },

    updateExamSettings: (state, action) => {
      state.examSettings = { ...state.examSettings, ...action.payload };
    },

    setExamProgress: (state, action) => {
      const { progress } = action.payload;
      if (state.currentExamData) {
        state.currentExamData.progress = progress;
      }
    },

    saveExamAnswer: (state, action) => {
      const { questionId, answer, questionIndex } = action.payload;
      
      // Update answered questions array
      const existingAnswerIndex = state.answeredQuestions.findIndex(
        q => q.questionIndex === questionIndex
      );
      
      if (existingAnswerIndex >= 0) {
        state.answeredQuestions[existingAnswerIndex] = {
          questionIndex,
          questionId,
          answer,
          timestamp: new Date().toISOString()
        };
      } else {
        state.answeredQuestions.push({
          questionIndex,
          questionId,
          answer,
          timestamp: new Date().toISOString()
        });
      }
    },

    setExamMetadata: (state, action) => {
      const { metadata } = action.payload;
      if (state.currentExamData) {
        state.currentExamData.metadata = metadata;
      }
    },

    addExamResult: (state, action) => {
      state.examResultsArr.push(action.payload);
    },

    updateExamResult: (state, action) => {
      const { examId, updates } = action.payload;
      const examIndex = state.examResultsArr.findIndex(exam => exam.examId === examId);
      if (examIndex >= 0) {
        state.examResultsArr[examIndex] = {
          ...state.examResultsArr[examIndex],
          ...updates
        };
      }
    },

    clearExamError: (state) => {
      state.error = null;
    },

    setExamError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const {
  setResultData,
  setSelectedSubject,
  setResultStatus,
  setExamId,
  setIsAfterObjectiveModalOpen,
  setTutorMark,
  setFrom,
  setExamObj,
  setIsEmpty,
  setTutorResult,
  setIsGraded,
  setExamResultsArr,
  setPendingInterviewArr,
  startExam,
  endExam,
  updateCurrentQuestion,
  addAnsweredQuestion,
  updateTimeRemaining,
  resetExamState,
  updateExamSettings,
  setExamProgress,
  saveExamAnswer,
  setExamMetadata,
  addExamResult,
  updateExamResult,
  clearExamError,
  setExamError,
} = tutorExamSlice.actions;

export default tutorExamSlice.reducer;
